import { render } from "./StandardProjectSuccess.vue?vue&type=template&id=3d17777e&scoped=true"
import script from "./StandardProjectSuccess.vue?vue&type=script&lang=ts"
export * from "./StandardProjectSuccess.vue?vue&type=script&lang=ts"

import "./StandardProjectSuccess.vue?vue&type=style&index=0&id=3d17777e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3d17777e"

export default script